import React from "react";
import PropTypes from "prop-types";
import { formatNumber } from "@wrstudios/utils";
import { getHighestZestimateDifferences } from "../../../utils/listings";
import IllustrationOnlineValuations from "../../illustrations/IllustrationOnlineValuations";
import { useLive } from "../LiveProvider";
import Preview from "./LivePreview";

function LivePreviewOnlineValuations({ title }) {
  const { visibleListings } = useLive();
  const { priceDifferencePercentage } =
    getHighestZestimateDifferences(visibleListings);
  const format =
    Math.abs(priceDifferencePercentage) >= 0.1 ? "0.[0]" : "0.0[0]";

  return (
    <Preview
      illustration={<IllustrationOnlineValuations />}
      title={title}
      subTitle={
        priceDifferencePercentage
          ? `Up to ${formatNumber(
              Math.abs(priceDifferencePercentage),
              format
            )}% Variance`
          : "N/A"
      }
    />
  );
}

LivePreviewOnlineValuations.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewOnlineValuations;
